module.exports = __webpack_public_path__ + "1d36b0380abeda8008901ad3f8742433.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/cos/0C00000U7D.png
// module id = 1634
// module chunks = 0